// extracted by mini-css-extract-plugin
module.exports = {"site-title":"main_site-title_3P6WO","error":"main_error_1piXl","error-message":"main_error-message_1jkNk","pointer":"main_pointer_1mJNt"};